// import Vue from 'vue';
// import STORE from '@/store'
// import GLOBAL from '@/utils/global.js'

/********************debug提示相关********************/
// 开发版配置
let debugMode = false;
//true：开发版
//false：正式版

//测试版端口：9092

//正式版端口：9091
let baseURL = '';

let testVerName = '';


/********************默认参数相关********************/
// let topnavHeight = 70; // 比默认topnav高度多20
let topnavHeight = 52; // 调试之后的值，页面底部不会有白边


//消息队列正式版
let ACCOUNT = '';   //账号
let PASSWORD = '';  //密码
let HOST = '';  // 虚拟主机

//自动刷新
let autoRefreshFlag = true;

if (debugMode) {
    testVerName = '（测试版）';
    //开发版
    // baseURL = 'https://zdshop.mdline.cn:9092';
    baseURL = 'http://129.211.212.62:9090';
    //消息队列测试版
    ACCOUNT = 'zdshop_test';   //账号
    PASSWORD = 'L5&X8YNRy5sw';  //密码
    HOST = 'zdshop_test';  // 虚拟主机
} else {
    //正式版
    baseURL = 'https://zdshop.mdline.cn:9091'
    //消息队列正式版
    ACCOUNT = 'zdshop_old';   //账号
    PASSWORD = '7r^8S&UbTdKB';  //密码
    HOST = 'zdshop_old';  // 虚拟主机
}

export default {
    // debug提示相关
    debugMode,
    baseURL,
    testVerName,

    // 默认参数相关
    topnavHeight,
    ACCOUNT,
    PASSWORD,
    HOST,
    autoRefreshFlag,
}
